<template lang="pug">
  JsonExcel(:data="dataForExcel" type="xls" name="ENCABEZADOS_PROVEEDORES")
    v-btn(color='success' small dark )
      v-icon(small) mdi-arrow-collapse-up
      | Proveedor
</template>
<script>
import JsonExcel from 'vue-json-excel'
export default {
  props: ['FormPadre'],
  data: () => ({
    dataForExcel: [],
    form: []
  }),

  components: {
    JsonExcel
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.generarExcel()
      }
    }
  },

  methods: {
    generarExcel () {
      this.dataForExcel = []
      this.form.map(proveedor => {
        Object.keys(proveedor).forEach(function (key) {
          if (proveedor[key] === undefined || proveedor[key] === null) {
            proveedor[key] = ''
          }
        })
        let fila = {
          'NOMBRE': ``,
          'RIF': ``,
          'DIRECCION': ``,
          'TELEFONO': ``,
          'WEB': ``,
          'CORREO': ``
        }
        this.dataForExcel.push(fila)
      })
    }
  }
}
</script>
